import { useToast } from "@chakra-ui/react";
import { formatErrorResponse } from "./format-response-error";

export function handleErrorWithToast(toast: ReturnType<typeof useToast>) {
  return (error: unknown) =>
    toast({
      title: "Error",
      description: formatErrorResponse(error),
      status: "error",
      position: "top-right",
    });
}
